/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'stats': {
    width: 16,
    height: 16,
    viewBox: '0 0 100 100',
    data: '<path pid="0" d="M27.785 48.461H9.312a3.49 3.49 0 00-3.492 3.492v33.551A3.492 3.492 0 009.312 89h18.473a3.49 3.49 0 003.492-3.492V51.953a3.493 3.493 0 00-3.492-3.492zm-3.492 33.555H12.805V55.45h11.488zM59.223 32.988H40.75a3.49 3.49 0 00-3.492 3.492v49.023a3.49 3.49 0 003.492 3.492h18.473a3.49 3.49 0 003.492-3.492v-49.02a3.494 3.494 0 00-3.492-3.496zm-3.492 49.027H44.243V39.976H55.73zM90.656 18.695H72.187a3.49 3.49 0 00-3.492 3.492v63.32A3.49 3.49 0 0072.187 89H90.66a3.49 3.49 0 003.492-3.492v-63.32a3.494 3.494 0 00-3.496-3.492zm-3.492 63.32H75.68V25.679h11.488z"/>'
  }
})
